// import './styles/ActionModal.css'
import { useState,useEffect } from 'react';
import Action from '../../Action'
import Modal from 'react-modal';
import { modalPropTypes } from 'rsuite/esm/internals/Overlay/Modal';
// import Selector from '../Selector'
// import InputForm from '../InputForm';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ResetHost = ({ cisSelected,
    server,
    languaje,
    handleShowPopup,
    closePingModal,
    credentials,
    search_status,
    mode}) => {
    const [dataPing,setDataPing]=useState({data:[],loading:false,error:null})
    const [ejecuta,setEjecuta]=useState(false)
    const data={
      hostid: cisSelected.hostid,
  softwarekey: "windows10windowsupdate"
    }
    const Ejecutar=()=>{
        setEjecuta(true)
       
        setDataPing({data:dataPing.data,loading:true,error:null})
          const fetchDataPost = async () => {
            
         try {
             // console.log(localStorage.getItem('access_token'))
             const response = await fetch(server.url+'/api/v1/cassia/update_software/', {
               // const response = await fetch(server.url+'/api/v1/zabbix/hosts/actionz/'+ip+'/-1', {
               method: 'POST',  
               headers: {
                   'Content-Type': 'application/json',
                   Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                 },
              body:JSON.stringify(data)
             });
             if (response.ok) {
                 const data1 = await response.json();
                 setDataPing(data1)
                 handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['actionComplet'])),capitalizeFirstLetter((lang[languaje]['msgActCompl'])), true)
                 // if(!isOpen){
                 // handleShowPopup('Completado','Conexión SSH al dispositivo '+cisSelected.host+'  excitosa ','', true)
                 // }
                 setDataPing({data:data1,loading:false,error:null})
                 search_status()
             } else {
               const data1 = await response.json();
               handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['errorActionComplet']),data1.detail, false)
               setDataPing({data:dataPing.data.data.action=false,loading:false,error:null})
               throw new Error('Error en la solicitud');
               
             }
         } catch (error) {
              setDataPing({data:dataPing.data,loading:false,error:null})
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['errorActionComplet']),'Favor de reportar el error', false)
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
    // const Ejecutar=()=>{
    //     setEjecuta(true)
    //     const data={
    //         "hostid": cisSelected.hostid,
    //         "user": credentials.user,
    //         "pass_": credentials.pass_
    //       }
    //     setDataPing({data:dataPing.data,loading:true,error:null})
    //       const fetchDataPost = async () => {

    //      try {

    //         // console.log(localStorage.getItem('access_token'))
    //           const response = await fetch(server.url+'/api/v1/cassia/credentials', {
    //             // const response = await fetch(server.url+'/api/v1/zabbix/hosts/actionz/'+ip+'/-1', {
    //             method: 'POST',  
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    //               },
    //            body:JSON.stringify(data)
    //           });
    //          console.log(response)
    //           if (response.ok) {

    //             const data1 = await response.json();
    //             setDataPing(data1)
    //             console.log(data1)
    //             // if(!isOpen){
    //               handleShowPopup(((data1.success)?'Completado':data1.message),'Conexión SSH al dispositivo '+cisSelected.host+'  excitosa ','', true)
    //             // }
    //             setDataPing({data:data1,loading:false,error:null})


    //           } else {
    //             const data1 = await response.json();
    //             handleShowPopup('Error!!!','Sin conexión shh',data1.detail, false)
    //             setDataPing({data:dataPing.data.data.action=false,loading:false,error:null})
    //             throw new Error('Error en la solicitud');

    //           }
    //         } catch (error) {
    //           setDataPing({data:dataPing.data,loading:false,error:null})
    //           handleShowPopup('Error!!!','Sin conexión shh','Favor de reportar el error', false)
    //           console.error(error);
    //         }
    //       };

    //       fetchDataPost();

    // }
    return (
      <>
        <div className={'contActionModal'+mode}>
            <div className='titlePinglModal'>
            <div className='actionsTitle'>
                    <div className='textCardTitle' style={{color:(mode==''?'var(--main-color)':'var(--white-color)')}}>
                           {cisSelected.host}:
                              </div>
                              
                    </div>
                    <hr className={'lineTitlePing'+mode}></hr>
            </div>
            <div className='contAnimationActionModal'>
               
                <div className='contAnimation' style={{width:'80%',textAlign:'center'}}>

                    {
                        (ejecuta==false)?<p className={'msgErrorPing '} >
                        {/* (false)?<p className={'msgErrorPing '} > */}
                        {'Desea aplcar actualizaciones ?'}
                   </p>:
                       <>
                       { dataPing.loading===true?<section className="dots-container-action">
                       {/* { true?<section className="dots-container"> */}
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                        <div className="dots-action" style={{height:'15px'}}></div>
                    </section>:(dataPing.data.length!=0)?
                    <p className={( dataPing.success===true )?'msgPing':'msgErrorPing '} >
                         {dataPing.message}
                    </p>:<p className={'msgErrorPing '} >
                         {'Ocurrio un error y no pudo ejecutarce la accion!!!'}
                    </p>}
                       </>
                    }
                
                
                </div>
                {/* <div className=' constImg contSecondImg'>
                <div className='divImgPing'>
                    <img src="router_1.png"  className='icon-ping' alt="Logo"/>
                    </div>
                    <div className='divtextPing'>
                    {data.name_hostipC}
                    </div>
                </div> */}
            </div>
            <div className='contActionsActionModal'>
            <div className='menuActionData' style={{display:'flex'}}>
                          {(ejecuta==false)?<div className='menuActionCell' style={{border: 'unset',width:'25%'}}>
                              <Action origen='Azul' disabled={false} titulo={'Aceptar'} action={Ejecutar} />
                          </div>:''}
                          <div className='menuActionCell' style={{border: 'unset',width:'25%'}}>
                              <Action origen='Cancelar' disabled={false} titulo={'Salir'} action={closePingModal} />
                          </div>
                          </div>
            </div>
        </div>
             
</>
    );
};

  export default ResetHost